import * as React from 'react'

import { cn } from '@safe-global/views/utils/cn'

/**
 * Textarea Component
 *
 * Multi-line text input (textarea).
 *
 * @see https://ui.shadcn.com/docs/components/base/textarea
 *
 * @example
 * ```tsx
 * <Textarea placeholder="Enter text..." />
 * ```
 *
 * @remarks
 * Key Props:
 * - `placeholder`, `disabled`, `value`, `onChange`, `className` — extends native textarea props, see Base UI
 */

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-border focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 rounded-md border bg-input px-2.5 py-2 text-base shadow-xs transition-[color,box-shadow] focus-visible:ring-[3px] aria-invalid:ring-[3px] md:text-sm placeholder:text-muted-foreground flex field-sizing-content min-h-16 w-full outline-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
